export const STATUS_OPTIONS = ["pending", "awaiting_payment", "confirmed", "proposal_sent", "proposal_accepted", "cancelled", "completed", "archived"];

export const STATUS_COLORS = {
  pending: "bg-amber-500/20 text-amber-400 border-amber-500/30",
  awaiting_payment: "bg-orange-500/20 text-orange-400 border-orange-500/30",
  confirmed: "bg-emerald-500/20 text-emerald-400 border-emerald-500/30",
  proposal_sent: "bg-violet-500/20 text-violet-400 border-violet-500/30",
  proposal_accepted: "bg-teal-500/20 text-teal-400 border-teal-500/30",
  cancelled: "bg-red-500/20 text-red-400 border-red-500/30",
  completed: "bg-blue-500/20 text-blue-400 border-blue-500/30",
  archived: "bg-white/5 text-white/30 border-white/10"
};

export const STATUS_LABELS = {
  pending: "Pending",
  awaiting_payment: "Awaiting Payment",
  confirmed: "Confirmed",
  proposal_sent: "Proposal Sent",
  proposal_accepted: "Proposal Accepted",
  cancelled: "Cancelled",
  completed: "Completed",
  archived: "Archived"
};

export const ROLE_COLORS = {
  user: "bg-white/10 text-white/60",
  admin: "bg-[#C5A059]/20 text-[#C5A059]",
  super_admin: "bg-purple-500/20 text-purple-400"
};

const TIME_INTERVAL_MINUTES = 30;
export const TIME_SLOTS = [];
for (let h = 0; h < 24; h++) {
  for (let m = 0; m < 60; m += TIME_INTERVAL_MINUTES) {
    TIME_SLOTS.push(`${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`);
  }
}
